import { useMemo, useState } from "react";
import { isPlainObject } from "./analysisUtils";

const DeepAnalysisSidebar = ({ analysisByFile, selectedPaperKey, onSelectPaper }) => {
  const [search, setSearch] = useState("");

  const paperList = useMemo(() => {
    if (!analysisByFile || !isPlainObject(analysisByFile)) return [];
    let list = Object.keys(analysisByFile);
    list.sort((a, b) => a.localeCompare(b));
    const q = search.trim().toLowerCase();
    if (q) list = list.filter((name) => name.toLowerCase().includes(q));
    return list;
  }, [analysisByFile, search]);

  return (
    <div className="flex h-full flex-col rounded-xl border border-base-300 bg-base-100 shadow-sm">
      <div className="border-b border-base-300 p-3">
        <h3 className="font-semibold text-base-content">Papers</h3>
        <input
          type="text"
          placeholder="Search by filename…"
          className="input input-bordered input-sm mt-2 w-full"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto p-2">
        {paperList.length === 0 ? (
          <p className="text-sm text-base-content/60">No papers</p>
        ) : (
          <ul className="space-y-1">
            {paperList.map((filename) => {
              const sectionData = analysisByFile[filename];
              const pmid =
                isPlainObject(sectionData) && sectionData.study_design?.pmid
                  ? sectionData.study_design.pmid
                  : isPlainObject(sectionData) && sectionData.study_design?.response?.pmid
                    ? sectionData.study_design.response.pmid
                    : Object.values(sectionData || {}).find((s) => s?.pmid)?.pmid ?? "—";
              const isSelected = selectedPaperKey === filename;
              return (
                <li key={filename}>
                  <button
                    type="button"
                    className={`w-full rounded-lg px-3 py-2 text-left text-sm transition ${
                      isSelected
                        ? "bg-primary text-primary-content"
                        : "hover:bg-base-200"
                    }`}
                    onClick={() => onSelectPaper(filename)}
                  >
                    <div className="font-medium truncate" title={filename}>
                      {filename}
                    </div>
                    <div className="mt-0.5 text-xs opacity-80">
                      PMID: {pmid}
                    </div>
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default DeepAnalysisSidebar;
